import React from 'react';
import { Link } from 'react-router-dom';
import logoImage from '../assets/logo-neon-yellow.png';

const Header = () => {
  return (
    <>
      <header className="header">
        <div className="logo-container">
          <Link to="/">
            <img
              src={logoImage}
              alt="After Eight Logo"
              className="logo"
            />
            <div className="logo-text">
              AFTER EIGHT
            </div>
          </Link>
          <div className="subtitle">• COCKTAIL CLUB •</div>
        </div>
      </header>
      <div className="wave-container"></div>
    </>
  );
};

export default Header;
